const TitleBarTitle = ({children}) => {


    return (
        <h2 className="d-flex m-auto">{children}</h2>
    );
}

export default TitleBarTitle;